var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar"},[_c('div',{staticClass:"hamburger",on:{"click":_vm.toggleMenu}},[_c('div'),_c('div'),_c('div')]),_c('h1',[_vm._v(_vm._s(_vm.$t(_vm.title())))])])}
var staticRenderFns = []

export { render, staticRenderFns }